<!--
 * @Author: van
 * @Date: 2021-09-27 16:21:49
 * @LastEditors: van
 * @LastEditTime: 2021-10-07 11:19:43
-->
<template>
    <el-dialog
        class="shopifyListing"
        :visible.sync="shoplineListingVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1440px"
        :title="$t('goodsList.shoplineListing.dialogTitle')"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container" v-loading="loading">
            <el-form ref="listingForm" :model="listingForm" label-width="150px" @keydown.enter.native.prevent>
                <!-- <el-tabs v-model="tabName">
                    <el-tab-pane
                        :label="$t('goodsList.shopifyListing.tabName1')"
                        :name="'1'"
                >-->
                <el-row>
                    <!-- 其他平台 -->
                    <el-col :span="12" v-if="platform_id != 4">
                        <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.shop')"
                                :rules="[
                                    {
                                        required: true,
                                        message: `${$t(
                                            'goodsList.shopifyListing.selectPlaceholder'
                                        )}${$t(
                                            'goodsList.shopifyListing.shop'
                                        )}`,
                                    },
                                ]"
                                prop="shop_id"
                                size="small"
                            >
                                <el-select
                                    v-model="listingForm.shop_id"
                                    size="small"
                                    clearable
                                    filterable
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.selectPlaceholder'
                                    )}${$t('goodsList.shopifyListing.shop')}`"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="item in shopList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                :label="
                                    $t('goodsList.shopifyListing.goods_name')
                                "
                                :rules="[
                                    {
                                        required: true,
                                        message: `${$t(
                                            'goodsList.shopifyListing.inputPlaceholder'
                                        )}${$t(
                                            'goodsList.shopifyListing.goods_name'
                                        )}`,
                                    },
                                ]"
                                prop="goods_name"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t(
                                        'goodsList.shopifyListing.goods_name'
                                    )}`"
                                    maxlength="200"
                                    size="small"
                                    v-model="listingForm.goods_name"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.category')"
                                :rules="[
                                    {
                                        required: true,
                                        message: `${$t(
                                            'goodsList.shopifyListing.inputPlaceholder'
                                        )}${$t(
                                            'goodsList.shopifyListing.category'
                                        )}`,
                                    },
                                ]"
                                prop="category"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="listingForm.category"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t(
                                        'goodsList.shopifyListing.category'
                                    )}`"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="SKU"
                                :rules="[
                                    {
                                        required: true,
                                        message: `${$t(
                                            'goodsList.shopifyListing.inputPlaceholder'
                                        )}SKU`,
                                    },
                                ]"
                                prop="sku"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}SKU`"
                                    maxlength="200"
                                    size="small"
                                    v-model="listingForm.sku"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.barcode')"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="listingForm.barcode"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t(
                                        'goodsList.shopifyListing.barcode'
                                    )}`"
                                ></el-input>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.tags')"
                                size="small"
                            >
                                <tagsInput
                                    :tagsList.sync="listingForm.tags"
                                    :title="$t('goodsList.shopifyListing.tags')"
                                    :visible="shoplineListingVisible"
                                ></tagsInput>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.keyword')"
                                size="small"
                            >
                                <tagsInput
                                    :tagsList.sync="listingForm.keyword"
                                    :title="
                                        $t('goodsList.shopifyListing.keyword')
                                    "
                                    :visible="shoplineListingVisible"
                                ></tagsInput>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                                    <el-form-item
                                        :label="
                                            $t(
                                                'goodsList.shopifyListing.product_type'
                                            )
                                        "
                                        size="small"
                                    >
                                        <el-input
                                            clearable
                                            size="small"
                                            v-model="listingForm.product_type"
                                            :placeholder="`${$t(
                                                'goodsList.shopifyListing.inputPlaceholder'
                                            )}${$t(
                                                'goodsList.shopifyListing.product_type'
                                            )}`"
                                        >
                                        </el-input>
                                    </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.vendor')"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="listingForm.vendor"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t('goodsList.shopifyListing.vendor')}`"
                                ></el-input>
                            </el-form-item>
                        </el-col>-->
                        <el-col :span="24">
                            <el-form-item
                                :label="
                                    $t(
                                        'goodsList.shopifyListing.published_scope'
                                    )
                                "
                                size="small"
                            >
                                <el-select
                                    v-model="listingForm.published_scope"
                                    size="small"
                                    clearable
                                    filterable
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t(
                                        'goodsList.shopifyListing.published_scope'
                                    )}`"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(
                                            item, index
                                        ) in published_scopeList"
                                        :key="index"
                                        :label="item"
                                        :value="item"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                :label="
                                    $t(
                                        'goodsList.shopifyListing.listing_status'
                                    )
                                "
                                size="small"
                                style="text-align: left"
                            >
                                <el-radio-group
                                    v-model="listingForm.listing_status"
                                >
                                    <el-radio :label="'draft'">Draft</el-radio>
                                    <el-radio :label="'active'"
                                        >Active</el-radio
                                    >
                                    <el-radio :label="'archived'"
                                        >Archived</el-radio
                                    >
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="24">
                                    <el-form-item
                                        :label="
                                            $t('goodsList.shopifyListing.type')
                                        "
                                        size="small"
                                        :label-width="
                                            $i18n.locale == 'zh'
                                                ? '100px'
                                                : '110px'
                                        "
                                        style="text-align: left"
                                    >
                                        <el-radio-group
                                            v-model="listingForm.type"
                                            @change="typeChange"
                                        >
                                            <el-radio :label="2">{{
                                                $i18n.locale == "zh"
                                                    ? "是"
                                                    : "yes"
                                            }}</el-radio>
                                            <el-radio :label="1">{{
                                                $i18n.locale == "zh"
                                                    ? "否"
                                                    : "no"
                                            }}</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                        </el-col>-->
                    </el-col>
                    <!-- 店匠 -->
                    <el-col :span="12" v-else>
                        <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.shop')"
                                :rules="[
                                    {
                                        required: true,
                                        message: `${$t(
                                            'goodsList.shopifyListing.selectPlaceholder'
                                        )}${$t(
                                            'goodsList.shopifyListing.shop'
                                        )}`,
                                    },
                                ]"
                                prop="shop_id"
                                size="small"
                            >
                                <el-select
                                    v-model="listingForm.shop_id"
                                    size="small"
                                    clearable
                                    filterable
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.selectPlaceholder'
                                    )}${$t('goodsList.shopifyListing.shop')}`"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="item in shopList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                :label="
                                    $t('goodsList.shopifyListing.goods_name')
                                "
                                :rules="[
                                    {
                                        required: true,
                                        message: `${$t(
                                            'goodsList.shopifyListing.inputPlaceholder'
                                        )}${$t(
                                            'goodsList.shopifyListing.goods_name'
                                        )}`,
                                    },
                                ]"
                                prop="goods_name"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t(
                                        'goodsList.shopifyListing.goods_name'
                                    )}`"
                                    maxlength="200"
                                    size="small"
                                    v-model="listingForm.goods_name"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Brief"
                                prop="brief"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )} Brief`"
                                    maxlength="200"
                                    size="small"
                                    v-model="listingForm.brief"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="SPU"
                                :rules="[
                                    {
                                        required: true,
                                        message: `${$t(
                                            'goodsList.shopifyListing.inputPlaceholder'
                                        )}SPU`,
                                    },
                                ]"
                                prop="spu"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )} SPU`"
                                    maxlength="200"
                                    size="small"
                                    v-model="listingForm.spu"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.tags')"
                                size="small"
                            >
                                <tagsInput
                                    :tagsList.sync="listingForm.tags"
                                    :title="$t('goodsList.shopifyListing.tags')"
                                    :visible="shoplineListingVisible"
                                ></tagsInput>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="SEO Title" size="small">
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="listingForm.meta_title"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )} SEO Title`"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="SEO Description" size="small">
                                <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 4, maxRow: 8 }"
                                    clearable
                                    size="small"
                                    v-model="listingForm.meta_description"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )} SEO Description`"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="SEO Keyword" size="small">
                                <!-- <tagsInput
                                    :tagsList.sync="listingForm.meta_keyword"
                                    title="SEO Keyword"
                                    :visible="shoplineListingVisible"
                                ></tagsInput> -->
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="listingForm.meta_keyword"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )} SEO Keyword`"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.vendor')"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="listingForm.vendor"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t('goodsList.shopifyListing.vendor')}`"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="Vendor URL" size="small">
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="listingForm.vendor_url"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )} Vendor URL`"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="Published" size="small">
                                <el-switch
                                    v-model="listingForm.published"
                                    :active-value="1"
                                    :inactive-value="0"
                                ></el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="Shipping" size="small">
                                <el-switch
                                    v-model="listingForm.shipping"
                                    :active-value="1"
                                    :inactive-value="0"
                                ></el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="Taxable" size="small">
                                <el-switch
                                    v-model="listingForm.taxable"
                                    :active-value="1"
                                    :inactive-value="0"
                                ></el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Tracking Inventory"
                                size="small"
                                class="el-form-item--checkbox inventory"
                                prop="inventory_policy"
                                :rules="[
                                    {
                                        required:
                                            listingForm.inventory_tracking,
                                        message: `${$t(
                                            'goodsList.shopifyListing.selectPlaceholder'
                                        )} Tracking Inventory`,
                                    },
                                ]"
                            >
                                <el-checkbox
                                    v-model="listingForm.inventory_tracking"
                                    @change="trackingChange"
                                    :true-label="true"
                                    :false-label="false"
                                ></el-checkbox>
                                <el-select
                                    v-model="listingForm.inventory_policy"
                                    size="small"
                                    clearable
                                    filterable
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )} Tracking Inventory`"
                                >
                                    <el-option
                                        v-for="(
                                            item, index
                                        ) in inventory_policyList"
                                        :key="index"
                                        :label="item"
                                        :value="item"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Fake Sales"
                                size="small"
                                class="el-form-item--checkbox"
                                prop="fake_sales"
                                :rules="[
                                    {
                                        required:
                                            listingForm.display_fake_sales,
                                        message: `${$t(
                                            'goodsList.shopifyListing.inputPlaceholder'
                                        )} Fake Sales`,
                                    },
                                ]"
                            >
                                <el-checkbox
                                    v-model="listingForm.display_fake_sales"
                                    :true-label="true"
                                    :false-label="false"
                                ></el-checkbox>
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="listingForm.fake_sales"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )} Fake Sales`"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Picture" size="small">
                            <imgUpload
                                :images="listingForm.goods_images"
                                ref="uploadsRef"
                                @imagesChange="imagesChange"
                                :multiple="true"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            :label="$t('goodsList.shopifyListing.goods_desc')"
                            size="small"
                        >
                            <vue-tinymce
                                v-model="listingForm.goods_desc"
                                :setting="setting"
                                v-if="shoplineListingVisible"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="table">
                            <el-table
                                border
                                :data="listingForm.attribute"
                                ref="attribute"
                                highlight-current-row
                                max-height="500px"
                            >
                                <el-table-column
                                    :label="
                                        $t('goodsList.shopifyListing.images')
                                    "
                                    align="center"
                                    width="80"
                                >
                                    <template slot-scope="scope">
                                        <el-image
                                            style="width: 60px; height: 60px"
                                            class="elImage_show"
                                            :src="scope.row.images[0]"
                                            fit="contain"
                                            @click="updateImg(scope)"
                                        >
                                            <div
                                                slot="error"
                                                class="image-slot"
                                            >
                                                <i
                                                    class="
                                                        el-icon-picture-outline
                                                    "
                                                ></i>
                                            </div>
                                            <div
                                                slot="placeholder"
                                                class="image-slot"
                                            >
                                                <i class="el-icon-loading"></i>
                                            </div>
                                        </el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="SKU"
                                    align="center"
                                    width="200"
                                >
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: true }]"
                                            :prop="
                                                'attribute.' +
                                                scope.$index +
                                                '.sku'
                                            "
                                        >
                                            <el-input
                                                clearable
                                                placeholder="SKU"
                                                maxlength="100"
                                                size="small"
                                                v-model="scope.row.sku"
                                            ></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="UPC"
                                    align="center"
                                    prop="upc"
                                    width="120"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            clearable
                                            placeholder="UPC"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.upc"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="HSCode"
                                    align="center"
                                    prop="hscode"
                                    width="120"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            placeholder="HSCode"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.hscode"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :label="
                                        $t('goodsList.shopifyListing.price')
                                    "
                                    align="center"
                                    prop="price"
                                    width="140"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            :placeholder="
                                                $t(
                                                    'goodsList.shopifyListing.price'
                                                )
                                            "
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.price"
                                        >
                                            <template slot="prepend">{{
                                                scope.row.currency
                                            }}</template>
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column
                                            :label="
                                                $t(
                                                    'goodsList.shopifyListing.currency'
                                                )
                                            "
                                            align="center"
                                            prop="currency"
                                            width="120"
                                        >
                                            <template slot-scope="scope">
                                                <el-form-item
                                                    label-width="0"
                                                    :rules="[
                                                        { required: true },
                                                    ]"
                                                    :prop="
                                                        'attribute.' +
                                                        scope.$index +
                                                        '.currency'
                                                    "
                                                >
                                                    <el-select
                                                        v-model="
                                                            scope.row.currency
                                                        "
                                                        size="small"
                                                        :placeholder="
                                                            $t(
                                                                'goodsList.shopifyListing.currency'
                                                            )
                                                        "
                                                        filterable
                                                        clearable
                                                    >
                                                        <el-option
                                                            v-for="item in currencyList"
                                                            :key="item.id"
                                                            :label="item.code"
                                                            :value="item.code"
                                                        ></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </template>
                                </el-table-column>-->
                                <el-table-column
                                    :label="
                                        $t('goodsList.shopifyListing.stock')
                                    "
                                    align="center"
                                    prop="stock"
                                    width="120"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            :placeholder="
                                                $t(
                                                    'goodsList.shopifyListing.stock'
                                                )
                                            "
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.stock"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :label="
                                        $t('goodsList.shopifyListing.value')
                                    "
                                    align="center"
                                    prop="value"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            :placeholder="`${$t(
                                                'goodsList.shopifyListing.inputPlaceholder'
                                            )}${$t(
                                                'goodsList.shopifyListing.value'
                                            )}`"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.value"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    :label="
                                        $t('goodsList.shopifyListing.operation')
                                    "
                                    :key="item"
                                    width="100"
                                >
                                    <template slot-scope="scope">
                                        <el-button
                                            type="text"
                                            icon="el-icon-minus"
                                            style="color: red"
                                            @click="
                                                minusItem_attributeTable(scope)
                                            "
                                        ></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
                <!-- </el-tab-pane>
                    <el-tab-pane
                        :label="$t('goodsList.shopifyListing.tabName2')"
                        :name="'2'"
                    >
                        <div class="table">
                            <el-table
                                border
                                :data="listingForm.attribute"
                                ref="attribute"
                                highlight-current-row
                                max-height="500px"
                            >
                                <el-table-column
                                    :label="
                                        $t('goodsList.shopifyListing.images')
                                    "
                                    align="center"
                                    width="80"
                                >
                                    <template slot-scope="scope">
                                        <el-image
                                            style="width: 60px; height: 60px"
                                            class="elImage_show"
                                            :src="scope.row.images[0]"
                                            fit="contain"
                                            @click="updateImg(scope)"
                                        >
                                            <div
                                                slot="error"
                                                class="image-slot"
                                            >
                                                <i
                                                    class="
                                                        el-icon-picture-outline
                                                    "
                                                ></i>
                                            </div>
                                            <div
                                                slot="placeholder"
                                                class="image-slot"
                                            >
                                                <i class="el-icon-loading"></i>
                                            </div>
                                        </el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="SKU"
                                    align="center"
                                    width="200"
                                >
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: true }]"
                                            :prop="
                                                'attribute.' +
                                                scope.$index +
                                                '.sku'
                                            "
                                        >
                                            <el-input
                                                clearable
                                                placeholder="SKU"
                                                maxlength="100"
                                                size="small"
                                                v-model="scope.row.sku"
                                            ></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="UPC"
                                    align="center"
                                    prop="upc"
                                    width="120"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            clearable
                                            placeholder="UPC"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.upc"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="HSCode"
                                    align="center"
                                    prop="hscode"
                                    width="120"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            placeholder="HSCode"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.hscode"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :label="
                                        $t('goodsList.shopifyListing.price')
                                    "
                                    align="center"
                                    prop="price"
                                    width="120"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            :placeholder="
                                                $t(
                                                    'goodsList.shopifyListing.price'
                                                )
                                            "
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.price"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :label="
                                        $t('goodsList.shopifyListing.currency')
                                    "
                                    align="center"
                                    prop="currency"
                                    width="120"
                                >
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: true }]"
                                            :prop="
                                                'attribute.' +
                                                scope.$index +
                                                '.currency'
                                            "
                                        >
                                            <el-select
                                                v-model="scope.row.currency"
                                                size="small"
                                                :placeholder="
                                                    $t(
                                                        'goodsList.shopifyListing.currency'
                                                    )
                                                "
                                                filterable
                                                clearable
                                            >
                                                <el-option
                                                    v-for="item in currencyList"
                                                    :key="item.id"
                                                    :label="item.code"
                                                    :value="item.code"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :label="
                                        $t('goodsList.shopifyListing.stock')
                                    "
                                    align="center"
                                    prop="stock"
                                    width="120"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            :placeholder="
                                                $t(
                                                    'goodsList.shopifyListing.stock'
                                                )
                                            "
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.stock"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :label="
                                        $t('goodsList.shopifyListing.value')
                                    "
                                    align="center"
                                    prop="value"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            :placeholder="`${$t(
                                                'goodsList.shopifyListing.inputPlaceholder'
                                            )}${$t(
                                                'goodsList.shopifyListing.value'
                                            )}`"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.value"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    :label="
                                        $t('goodsList.shopifyListing.operation')
                                    "
                                    :key="item"
                                    width="100"
                                    v-if="listingForm.type == 2"
                                >
                                    <template slot-scope="scope">
                                        <el-button
                                            type="text"
                                            icon="el-icon-minus"
                                            style="color: red"
                                            @click="
                                                minusItem_attributeTable(scope)
                                            "
                                        ></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                </el-tabs>-->
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >{{ $t("goodsList.shopifyListing.save") }}</el-button
            >
            <el-button size="small" @click="shoplineListingVisible = false">
                {{ $t("goodsList.shopifyListing.close") }}
            </el-button>
        </span>
        <updateImg
            :updateImgVisible.sync="updateImgVisible"
            :tableItemIndex.sync="tableItemIndex"
            :imagesList="imagesList"
            @imgUrl="imgUrl"
            :type="'detail'"
        ></updateImg>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapState } from "vuex";
import updateImg from "./updateImg";
import tagsInput from "@/common/components/tags-input";
import imgUpload from "components/imgUpload";
export default {
    data() {
        return {
            oldAttribute: [],
            listingForm: {
                goods_name: "", //产品名称
                goods_desc: "", // 产品描述
                category: "", // 产品分类
                category_id: "",
                keyword: [], // 关键字
                sku: "", // 产品sku
                barcode: "", // 产品条码
                tags: [], // 标签
                goods_images: [], // 刊登图片
                attribute: [
                    {
                        images: [], // 产品图片
                        sku: "", //属性sku
                        name: "", //属性名称
                        value: "", // 属性值
                        upc: "", // 多属性产品条码
                        hscode: "", // 海关hs号
                        price: "", // 价格
                        stock: "", // 库存
                        currency: "", //货币
                    },
                ],
                type: 1, //类型1-单品 2-多属性
                platform_id: "",
                shop_id: "",
                listing_status: "draft",
                // product_type: "",
                published_scope: "",
                // 店匠
                brief: "",
                spu: "",
                meta_title: "",
                meta_description: "",
                meta_keyword: "",
                vendor: "",
                vendor_url: "",
                published: 0,
                shipping: 0,
                taxable: 0,
                note: "",
                inventory_policy: "",
                inventory_tracking: false,
                fake_sales: "",
                display_fake_sales: false,
            },
            published_scopeList: ["web", "global"],
            imagesList: [],
            updateImgVisible: false,
            tableItemIndex: "",
            emptyTableItem: {
                images: [], // 产品图片
                sku: "", //属性sku
                name: "", //属性名称
                upc: "", // 多属性产品条码
                hscode: "", // 海关hs号
                price: "", // 价格
                stock: "", // 库存
                currency: "", //货币
            },
            shopList: [],
            tabName: "1",
            loading: false,
            inventory_policyList: ["continue", "deny", "auto_unpublished"],
        };
    },
    methods: {
        imagesChange(images) {
            this.listingForm.goods_images = images;
        },
        save() {
            this.$refs["listingForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    // singleShoplazzaPublication
                    // singlePublication
                    cmofferApi[
                        this.platform_id != 4
                            ? "singlePublication"
                            : "singleShoplazzaPublication"
                    ](
                        {
                            ...this.listingForm,
                            goods_id: this.listingForm.id,
                        },
                        "post"
                    )
                        .then((res) => {
                            if (res) {
                                this.$message.success("Product Publishing Done.");
                                // this.$parent.getGoodsList();
                                this.loading = false;
                                this.closeDialog();
                                this.$ga.event(
                                    "engagement",
                                    "prod_publish",
                                );
                            } else {
                                this.$message.error("Publish failed, please contact our support with screenshots or product link.")
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        },
        closeDialog() {
            this.listingForm = {
                goods_name: "", //产品名称
                goods_desc: "", // 产品描述
                category: "", // 产品分类
                category_id: "",
                keyword: [], // 关键字
                sku: "", // 产品sku
                barcode: "", // 产品条码
                tags: [], // 标签
                goods_images: [], // 刊登图片
                attribute: [
                    {
                        images: [], // 产品图片
                        sku: "", //属性sku
                        name: "", //属性名称
                        value: "", // 属性值
                        upc: "", // 多属性产品条码
                        hscode: "", // 海关hs号
                        price: "", // 价格
                        stock: "", // 库存
                        currency: "", //货币
                    },
                ],
                type: 1, //类型1-单品 2-多属性
                platform_id: "",
                shop_id: "",
                listing_status: "draft",
                // product_type: "",
                vendor: "",
                published_scope: "",
                // 店匠
                brief: "",
                spu: "",
                meta_title: "",
                meta_description: "",
                meta_keyword: [],
                vendor_url: "",
                published: "",
                shipping: "",
                taxable: "",
                note: "",
                inventory_policy: "",
                // inventory_tracking: false,
                fake_sales: "",
                // display_fake_sales: false,
            };
            this.tabName = "1";
            this.$refs["listingForm"].clearValidate();
            this.$refs["listingForm"].resetFields();
            this.$emit("update:shoplineListingVisible", false);
        },
        // addItem_attributeTable(row) {
        //     this.emptyTableItem = {
        //         images: [], // 产品图片
        //         sku: "", //属性sku
        //         name: "", //属性名称
        //         value: "", // 属性值
        //         upc: "", // 多属性产品条码
        //         hscode: "", // 海关hs号
        //         price: "", // 价格
        //         stock: "", // 库存
        //     };
        //     let dataTemplate = JSON.parse(JSON.stringify(this.emptyTableItem));
        //     if (this.listingForm.attribute.length == 0 || row) {
        //         this.listingForm.attribute.push(dataTemplate);
        //     }
        // },
        updateImg(scope) {
            this.imagesList = scope.row.images;
            this.updateImgVisible = true;
            this.tableItemIndex = scope.$index;
        },
        imgUrl(params) {
            this.listingForm.attribute[this.tableItemIndex].images = params;
        },
        minusItem_attributeTable(scope) {
            if (this.listingForm.attribute.length > 1) {
                for (let i in this.listingForm.attribute) {
                    if (i == scope.$index) {
                        this.listingForm.attribute.splice(i, 1);
                    }
                }
            } else {
                return false;
            }
        },
        typeChange(val) {
            if (val == 1 && this.listingForm.attribute.length > 1) {
                this.oldAttribute = JSON.parse(
                    JSON.stringify(this.listingForm.attribute)
                );
                this.listingForm.attribute.splice(
                    1,
                    this.listingForm.attribute.length - 1
                );
            } else if (val == 2 && this.oldAttribute.length > 1) {
                for (let i = 1; i < this.oldAttribute.length; i++) {
                    this.listingForm.attribute.push(this.oldAttribute[i]);
                }
            }
        },
        currencySelect() {
            cmofferApi.currencySelect({}, "get").then((res) => {
                if (res) {
                    this.currencyList = res.data;
                }
            });
        },
        getGoodsList() {
            cmofferApi
                .productDetail({}, "get", this.productData.id)
                .then((res) => {
                    if (res) {
                        this.listingForm = {
                            ...res.data,
                            platform_id: "",
                            shop_id: "",
                            listing_status: "draft",
                            goods_images: res.data.goods_images, // 刊登图片
                            sku: res.data.spu,
                            category: res.data.catalog_names.toString(),
                            attribute: res.data.goods_attribute,
                            type: res.data.goods_attribute.length <= 1 ? 1 : 2, //类型1-单品 2-多属性
                            inventory_tracking: false,
                            display_fake_sales: false,
                        };
                        this.loading = false;
                    }
                });
        },
        shopSelect() {
            cmofferApi
                .shopSelect({ platform_id: this.platform_id }, "get")
                .then((res) => {
                    if (res) {
                        this.shopList = res.data;
                    }
                });
        },
        magic(scope, key) {
            if (key instanceof Array) {
                for (let i = 0; i < key.length; i++) {
                    this.magic(scope, key[i]);
                }
                return;
            }
            /* if (key == "gross_weight" || key == "net_weight") {
                if (this.listingForm.attributes[0][key] == 0) {
                    return false;
                }
            } */
            let value = this.listingForm.attributes[0][key];
            for (let i in this.listingForm.attributes) {
                this.$set(this.listingForm.attributes[i], key, value);
            }
        },
        trackingChange(val){
            if(val && !this.listingForm.inventory_policy){
                this.$set(this.listingForm, "inventory_policy", this.inventory_policyList[0])
            }else if(!val && this.listingForm.inventory_policy){
                this.$set(this.listingForm, "inventory_policy", "")
            }
        }
    },
    components: {
        imgUpload,
        updateImg: updateImg,
        tagsInput: tagsInput,
    },
    props: {
        shoplineListingVisible: Boolean,
        productData: Object,
        platform_id: Number,
    },
    computed: {
        ...mapState({
            setting: (state) =>
                Object.assign(JSON.parse(JSON.stringify(state.index.setting)), {
                    height: 400,
                }),
        }),
    },
    watch: {
        shoplineListingVisible() {
            if (this.shoplineListingVisible) {
                this.loading = true;
                this.shopSelect();
                this.currencySelect();
                this.getGoodsList();
            }
        },
    },
};
</script>
<style lang="scss">
.shopifyListing {
    .container {
        width: 100%;
        .el-upload--picture-card {
            float: left !important;
            margin-right: 10px;
        }
        .uploadBox {
            .el-upload,
            .el-upload--text {
                width: 100%;
                height: 100%;
            }
        }
        .describeContent {
            line-height: 1.6;
        }
        .addAttribute {
            color: $color-primary;
            text-align: left;
        }
        .table {
            .el-form-item {
                margin: 0;
            }
        }
        .el-form-item--checkbox {
            .el-form-item__content {
                display: flex;
                align-items: center;
            }
            .el-checkbox {
                margin: 0 10px 0 0;
            }
        }
        .inventory {
        }
    }
    .el-select--small {
        width: 100%;
    }
}
</style>
